<template>
	<el-dialog title="导入达人信息" :visible.sync="dialogVisible" width="520px" :before-close="handleClose">
		<div class="yx-color-text-primary fz-16">
			<div class="font-bold">数据导入中…</div>
			<div class="mt-8">
				关闭弹窗不影响数据上传状态，您可在
				<span class="yx-color-primary pointer" @click="goToPage">【导入记录】</span>
				中查看数据上传进度及结果
			</div>
		</div>
		<span slot="footer">
			<el-button type="primary" @click="handleClose">关闭</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'hintDialog',
	props: {
		sourcePage: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			dialogVisible: false,
		};
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
		},
		goToPage() {
			console.log('this.sourcePage', this.sourcePage);
			const url = {
				myTalent: '/talentCRM/myTalent/importLog',
				emphasisTalent: '/talentCRM/emphasisTalent/importLog',
				groupSeas: '/talentCRM/groupSeas/importLog',
			};

			this.$router.push(url[this.sourcePage]);
			this.handleClose();
		},
	},
};
</script>

<style lang="less" scoped></style>
